"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("../../../utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Legend(props) {
  var dataExternal = props.dataExternal,
      legendLabels = props.legendLabels;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "projection-legend"
  }, dataExternal.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "projection-legend-item legend-external-item-".concat(index),
      key: (0, _index.createUniqueKey)(index, item.name)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "legend-point"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "legend-name"
    }, item.name));
  }), legendLabels.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "projection-legend-item legend-item-".concat(index),
      key: (0, _index.createUniqueKey)(index, item)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "legend-point"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "legend-name"
    }, item));
  }));
}

Legend.propTypes = {
  dataExternal: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired
  })),
  legendLabels: _propTypes.default.arrayOf(_propTypes.default.string)
};
Legend.defaultProps = {
  dataExternal: [],
  legendLabels: []
};
var _default = Legend;
exports.default = _default;